import { render, staticRenderFns } from "./HeroSection.vue?vue&type=template&id=77e4edd3&scoped=true&"
import script from "./HeroSection.vue?vue&type=script&lang=js&"
export * from "./HeroSection.vue?vue&type=script&lang=js&"
import style0 from "./HeroSection.vue?vue&type=style&index=0&id=77e4edd3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e4edd3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BackgroundResponsive: require('/opt/build/repo/apps/shop/components/BackgroundResponsive.vue').default})
